import React from 'react';

import { useImageLoadFailure } from './useImageLoadFailure';
import { ImageUnavailable, QuestionImage, QuestionImageRow } from './styles';

type AuditQuestionImageProps = {
  questionKey: string;
  url: string;
  label: string;
};

// Its own component: AuditQuestionRow returns before any hook, so the state can't live there.
const AuditQuestionImage: React.FunctionComponent<AuditQuestionImageProps> = ({ questionKey, url, label }) => {
  const [failed, onError] = useImageLoadFailure(url);

  return (
    <QuestionImageRow>
      {failed ? (
        <ImageUnavailable data-testid={`audit-question-image-unavailable-${questionKey}`}>
          Image unavailable
        </ImageUnavailable>
      ) : (
        <QuestionImage
          src={url}
          loading="lazy"
          alt={label}
          onError={onError}
          data-testid={`audit-question-image-${questionKey}`}
        />
      )}
    </QuestionImageRow>
  );
};

export default AuditQuestionImage;
